import React, { Component } from "react";
import templates from "../components/FormTemplates";
import { connect } from "react-redux";
import dynamicPortal from "../utils/dynamicPortal";
import actions from "../actions/shop";
import Form from "../components/Form/Form";
import List from "../components/ShopOverview/List";

export class ShopOverviewPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-shop-overview", (config) => {
      return (
        <React.Fragment>
          <div className="theme--accent">
            <div className="container container--center container--clearfix">
              <div className="container container--margin">
                <Form
                  config={config.filters}
                  templates={templates}
                  onSubmit={async (values) =>
                    await this.handleSubmit(values, config)
                  }
                />
              </div>
            </div>
          </div>
          <List config={config} />
        </React.Fragment>
      );
    });
  }

  async handleSubmit(values, config) {
    this.props.productsFiltersChanged(values);

    if (this.props.shop && this.props.shop.productsInfo) return;
    if (!config.list || !config.list.sourceUrl) {
      console.error(
        "Cannot get products: config.filter.sourceUrl missing in js-react-shop-overview"
      );
      return;
    }

    if (!this.props.shop.loading)
      this.props.requestProducts(config.list.sourceUrl);
  }
}

export default connect(
  (state) => ({
    shop: state.shop,
  }),
  {
    requestProducts: actions.requestProducts,
    receivedProducts: actions.receivedProducts,
    failedProducts: actions.failedProducts,
    productsFiltersChanged: actions.productsFiltersChanged,
  }
)(ShopOverviewPortal);



// WEBPACK FOOTER //
// ./src/portals/ShopOverviewPortal.js